import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getCartOptions(cartGuid: string) {
  return queryOptions({
    queryFn: () => service.getCart({ cartGuid }),
    queryKey: ['cart', cartGuid],
  });
}
